import { v4 as uuidv4 } from 'uuid'

interface Props {
  [key: string]: any
}

export default function HomLaptopIcon(props: Props): React.ReactElement {
  const { pathClassName, ...rest } = props
  const uuid = uuidv4()

  return (
    <svg fill="none" viewBox="0 0 48 48" {...rest} xmlns="http://www.w3.org/2000/svg">
      <path d="M14 38V35H34V38L47 38.521V40C47 40.6 46.6 41 46 41H2C1.4 41 1 40.6 1 40V38.6L14 38Z" fill="#A481D1" />
      <path
        d="M42 34H6C4.9 34 4 33.1 4 32V9C4 7.9 4.9 7 6 7H42C43.1 7 44 7.9 44 9V32C44 33.1 43.1 34 42 34Z"
        fill={`url(#${uuid}paint0_linear)`}
      />
      <path d="M42 9H6V32H42V9Z" fill={`url(#${uuid}paint1_linear)`} />
      <path
        d="M46.9241 38.3L44.0341 34.8C43.6351 34.3 43.0371 34 42.4391 34H5.56509C4.96709 34 4.36909 34.3 3.97009 34.8L1.08009 38.4C0.881093 38.7 1.08009 39.1 1.37909 39.1H16.3281C16.7271 39.1 17.0261 38.9 17.2251 38.5L17.6241 37.6C17.8231 37.3 18.1221 37 18.5211 37H29.2841C29.6831 37 29.9821 37.2 30.1811 37.6L30.5801 38.5C30.7791 38.8 31.0781 39.1 31.4771 39.1H46.4261C46.9241 39 47.1231 38.6 46.9241 38.3Z"
        fill="#7D38D6"
      />
      <path
        d="M34.5 15H19.5C19.224 15 19 14.776 19 14.5V13.5C19 13.224 19.224 13 19.5 13H34.5C34.776 13 35 13.224 35 13.5V14.5C35 14.776 34.776 15 34.5 15Z"
        fill="white"
      />
      <path
        d="M14 26.5V13.5C14 13.224 14.224 13 14.5 13H15.5C15.776 13 16 13.224 16 13.5V26.5C16 26.776 15.776 27 15.5 27H14.5C14.224 27 14 26.776 14 26.5Z"
        fill="white"
      />
      <path
        d="M34.5 19H19.5C19.224 19 19 18.776 19 18.5V17.5C19 17.224 19.224 17 19.5 17H34.5C34.776 17 35 17.224 35 17.5V18.5C35 18.776 34.776 19 34.5 19Z"
        fill="white"
      />
      <path
        d="M34.5 23H19.5C19.224 23 19 22.776 19 22.5V21.5C19 21.224 19.224 21 19.5 21H34.5C34.776 21 35 21.224 35 21.5V22.5C35 22.776 34.776 23 34.5 23Z"
        fill="white"
      />
      <path
        d="M30.5 27H19.5C19.224 27 19 26.776 19 26.5V25.5C19 25.224 19.224 25 19.5 25H30.5C30.776 25 31 25.224 31 25.5V26.5C31 26.776 30.776 27 30.5 27Z"
        fill="white"
      />
      <defs>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${uuid}paint0_linear`}
          x1="8.364"
          x2="38.396"
          y1="7.308"
          y2="32.646"
        >
          <stop stopColor="#7D38D6" />
          <stop offset="1" stopColor="#7D38D6" />
        </linearGradient>
        <linearGradient gradientUnits="userSpaceOnUse" id={`${uuid}paint1_linear`} x1="6" x2="42" y1="20.5" y2="20.5">
          <stop stopColor="#9AE6FF" />
          <stop offset="1" stopColor="#70B2FF" />
        </linearGradient>
      </defs>
    </svg>
  )
}
